export enum AssignmentCreationTypeEnum {
  Create = 'create',
  Renew = 'renew',
  EditDraft = 'editDraft',
  Edit = 'edit',
  EditRenew = ' editRenew',
  Template = ' template',
  EditTemplate = 'editTemplate',
  Rehire = 'rehire',
  EditRehire = 'editRehire',
}
